import React, { FC, useState, useCallback, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Routes } from '../../utils';
import { NetworkStatus } from '@apollo/client';
import { Query } from '../_common';
import { GET_ALL_DRIVERS_BY_MESSAGE } from '../../graphql/client/queries';
import { MARK_ALL_CONVERSATION_AS_READ } from '../../graphql/client/mutations';
import { Error, Loading } from '../_common';
import { useStoreContext } from '../App/StoreProvider';
import { debounce } from 'lodash';
import DriverListItem from './DriverListItem';
import { useMutation } from '@apollo/client/react';

import _ from 'lodash';
import * as MessageListActions from '../../store/actions/messageList';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

interface LooseObject {
    [key: string]: any;
}

interface MessageDriverListProps {
    history: any;
    match: any;
    refetchQuery: boolean;
    setRefetchQuery: any;
    refetchDriverList: boolean;
    setRefetchDriverList: any;
    setIsFetching: React.Dispatch<React.SetStateAction<boolean>>;
}

const PAGE_SIZE = 25;

const MessageDriverList: FC<MessageDriverListProps> = (props: MessageDriverListProps): React.ReactElement => {
    const [state, dispatch] = useStoreContext();
    const {
        messageList: { filters, dateFilter, driverSearch },
    } = state;
    const { regionIds, messageType, carrierIds } = filters;
    const abortController = React.useRef(new AbortController());

    const [searchInput, setSearchInput] = useState<string>(driverSearch);

    const [currentOffset, setCurrentOffset] = useState(1);
    const navigate = useNavigate();
    useEffect(() => {
        if (driverSearch.length == 0) {
            setSearchInput('');
        }
    }, [driverSearch]);

    const driverByMessageVariables = {
        input: {
            regionIds,
            carrierIds,
            searchString: driverSearch,
            pageSize: PAGE_SIZE,
            filterByOnLoad: false,
            filterByOnShift: false,
            filterByWaitOnLoad: false,
        },
        offset: 0,
    }

        if (messageType.length > 0) {
            driverByMessageVariables['input']['filterByOnLoad'] = messageType.indexOf('filterByOnLoad') > -1 ? true : false;
            driverByMessageVariables['input']['filterByOnShift'] =
                messageType.indexOf('filterByOnShift') > -1 ? true : false;
            driverByMessageVariables['input']['filterByWaitOnLoad'] =
                messageType.indexOf('filterByWaitOnLoad') > -1 ? true : false;    
        }

    const context = React.useMemo(()=>
    {return {
        fetchOptions: {
            signal: abortController.current.signal,
        },
    }},[abortController.current.signal]);

    const redirectToConversationHandler = React.useCallback(async (event: any, driver: LooseObject) => {
        // await markAllConversationAsRead({
        //     variables: { input: { conversationId: driver.conversatonId } },
        // });

        localStorage.setItem(
            'driverData_' + driver.resultId,
            JSON.stringify({
                name: driver.name,
                cellPhone: driver.cellPhone,
                loadId: driver.loadId,
                driver: { ...driver },
            }),
        );

        // if(driver.conversatonId) {
        //     console.log('driver.conversatonId', driver.conversatonId);
        //     props.history.push(`${Routes.MESSAGES.route}${driver.conversatonId}`);
        // }
        // else {
        //     props.history.push(`${Routes.MESSAGES.route}${driver.resultId}`);
        // }
        setSearchInput('');
        // dispatch(MessageListActions.resetFilterState());
        props.history(`${Routes.MESSAGES.route}${driver.resultId}`);
    },[]);

    const redirectToGroupConversationHandler = React.useCallback(async (event: any, driver: LooseObject) => {
        // await markAllConversationAsRead({
        //     variables: { input: { conversationId: driver.conversatonId } },
        // });
        localStorage.setItem(
            'driverData_' + driver.resultId,
            JSON.stringify({
                isGroupAl: true,
                cellPhone: 'Group Message',
                name: driver.conversationName,
                driver: { ...driver },
            }),
        );
        setSearchInput('');
        dispatch(MessageListActions.resetFilterState());
        props.history(`${Routes.MESSAGES.route}${driver.conversationId}`);
    },[]);

    const driverSearchHandler = (event: React.FormEvent<HTMLInputElement>) => {
        event.persist();
        setSearchInput(event.currentTarget.value);
    };

    return (
        <>
            <div className="Message-Search">
                <div className="row d-flex">
                    <div className="col-md-12 px-auto">
                        <div className="SearchBar-Container">
                            <i className="material-icons SearchBar-Icon">search</i>
                            <input
                                id="textSearch"
                                type="text"
                                placeholder="Search Drivers"
                                className="SearchBar-Input"
                                value={searchInput}
                                onChange={driverSearchHandler}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        dispatch(MessageListActions.setDriverSearchPhrase(searchInput));
                                        props.history(`${Routes.MESSAGES.route}`);
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    {/* <div className="col-md-3 pl-0 my-auto">
                        <div className="actions">
                            <a href={Routes.MESSAGES_CREATE.route} className="">
                                Create <FontAwesomeIcon icon={['fas', 'plus']} />
                            </a>
                        </div>
                    </div> */}
                </div>
            </div>
            <Query<LooseObject>
                query={GET_ALL_DRIVERS_BY_MESSAGE}
                variables={driverByMessageVariables}
                fetchPolicy="network-only"
                // nextFetchPolicy="cache-first"
                context={context}
                // notifyOnNetworkStatusChange={true}
                pollInterval={120000}
            >
                {({ error, data, loading, fetchMore, refetch, networkStatus }): React.ReactElement | null => {
                   
                    React.useEffect(() => {
                        // if(loading)
                        props.setIsFetching(loading);
                    }, [loading]);

                    React.useEffect(()=>{
                        
                        if (props.refetchQuery) {
                            refetch();
                            props.setRefetchQuery(false);
                        }
                    },[props.refetchQuery]);
        
                    if (error) {
                        return <Error error={error} />;
                    }
                    
                    const driverList: LooseObject[] = [];
                    let allDriverByMessageDataLength = 0;
                    if (
                        data &&
                        data.getAllDriversByMessage &&
                        data.getAllDriversByMessage.driverView &&
                        data.getAllDriversByMessage.driverView.length !== 0
                    ) {
                        allDriverByMessageDataLength = data.getAllDriversByMessage.driverView.length;
                        data.getAllDriversByMessage.driverView.forEach((element: LooseObject | null): void => {
                            if (element !== null) {
                                driverList.push(element);
                            }
                        });
                    }

                    // if driver list count is less than page size the append result of
                    // getAllSearchDrivers date
                    // if (allDriverByMessageDataLength < PAGE_SIZE * currentOffset && driverSearch.length == 0) {
                    //     if (
                    //         data &&
                    //         data.getAllSearchDrivers &&
                    //         data.getAllSearchDrivers.driverView &&
                    //         data.getAllSearchDrivers.driverView.length !== 0
                    //     ) {
                    //         data.getAllSearchDrivers.driverView.forEach((element: LooseObject | null): void => {
                    //             if (element !== null) {
                    //                 driverList.push(element);
                    //             }
                    //         });
                    //     }
                    // }

                    // if there is a driver search and there is no driver found in
                    // getAllDriverByMessage API then append result from getAllSearchDriver API
                    // if (driverList.length == 0 && driverSearch.length > 0) {
                    //     if (
                    //         data &&
                    //         data.getAllSearchDrivers &&
                    //         data.getAllSearchDrivers.driverView &&
                    //         data.getAllSearchDrivers.driverView.length !== 0
                    //     ) {
                    //         data.getAllSearchDrivers.driverView.forEach((element: LooseObject | null): void => {
                    //             if (element !== null) {
                    //                 driverList.push(element);
                    //             }
                    //         });
                    //     }
                    // }

                    // driverList = _.uniqBy(driverList, 'resultId');

                    const offset = Math.floor(driverList.length / PAGE_SIZE) || 0;
                    const totalCount = data && data.getAllDriversByMessage && data.getAllDriversByMessage.totalCount;
                    // setOffset(offsetNew);

                    let isEndOfResults = false;
                    if (totalCount == driverList.length) {
                        isEndOfResults = true;
                    }

                    return (
                        <DriverListItem
                            drivers={driverList}
                            refetch={refetch}
                            isLoading={loading}
                            isEndOfResults={isEndOfResults}
                            history={props.history}
                            match={props.match}
                            redirectToConversationHandler={redirectToConversationHandler}
                            redirectToGroupConversationHandler={redirectToGroupConversationHandler}
                            onLoadMore={() => {
                                fetchMore({
                                    variables: {
                                        offset,
                                    },
                                    updateQuery: (prev, { fetchMoreResult }) => {
                                        if (
                                            prev &&
                                            fetchMoreResult &&
                                            prev.getAllDriversByMessage &&
                                            fetchMoreResult.getAllDriversByMessage
                                        ) {
                                            return Object.assign(
                                                {},
                                                {
                                                    getAllDriversByMessage: {
                                                        __typename: prev.getAllDriversByMessage.__typename,
                                                        driverView: [
                                                            ...prev.getAllDriversByMessage.driverView,
                                                            ...fetchMoreResult.getAllDriversByMessage.driverView,
                                                        ],
                                                        totalCount: fetchMoreResult.getAllDriversByMessage.totalCount,
                                                    },
                                                },
                                            );
                                        } else {
                                            return prev;
                                        }
                                    },
                                });
                            }}
                        />
                    );
                }}
            </Query>
        </>
    );
};

export default MessageDriverList;
